import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  ReactElement,
} from "react";

import classnames from "classnames";

import { H4 } from "../Typography";

type EmptyStateProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  /**
   * Main title of the content
   */
  title: string;
  /**
   * Description
   * @default undefined
   */
  description?: string;
  /**
   * Action, a ReactElement that in most case should be a wombat Button or a Link
   */
  action: ReactElement;
};

const EmptyState: React.FC<EmptyStateProps> = ({
  children,
  title,
  description,
  action,
  className,
  ...props
}) => {
  const containerStyle = classnames(
    "items-center justify-center mx-auto flex flex-col space-y-3 min-h-xxs",
    className
  );

  return (
    <div className={containerStyle} {...props}>
      {children}
      <H4 description={description}>{title}</H4>
      {action}
    </div>
  );
};

export default React.memo(EmptyState);
